import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@store/auth/AuthProvider'

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)
  const hasAutoLoginParams = !!(searchParams.get('KUNNR') && searchParams.get('KUNNR2'))

  // Las URLs de autologin (?KUNNR=...&KUNNR2=...) siempre pasan por /login para
  // que se procese una sesion limpia, aunque exista una sesion previa activa.
  if (hasAutoLoginParams) {
    return <Navigate to={`/login${location.search}`} replace />
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // Conserva los query params (autologin legacy ?KUNNR=...&KUNNR2=...&USUARIO=...)
    return <Navigate to={`/login${location.search}`} replace />
  }

  return <Outlet />
}
